module.exports = __webpack_public_path__ + "static/course_first_steps_in_scala-30175bc4f8ebb6153cc138f81fc7bb4b.svg";